"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeHelper = (function () {
    function TimeHelper() {
    }
    TimeHelper.checkTime = function (i) {
        return (Number(i) < 10) ? "0" + i : i;
    };
    return TimeHelper;
}());
exports.default = TimeHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/helpers/time-helper.ts
// module id = 1999
// module chunks = 4